/* eslint-disable react/no-unknown-property */
import React from "react";

interface Props {
  color?: string;
}

export const BolinhasIcon = (props: Props) => (
  <svg
    width="83"
    height="95"
    viewBox="0 0 83 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.50646 8.54848C5.44302 8.54848 7.01292 6.75639 7.01292 4.54573C7.01292 2.33507 5.44302 0.542969 3.50646 0.542969C1.56989 0.542969 0 2.33507 0 4.54573C0 6.75639 1.56989 8.54848 3.50646 8.54848Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.4401 8.54848C24.3767 8.54848 25.9465 6.75639 25.9465 4.54573C25.9465 2.33507 24.3767 0.542969 22.4401 0.542969C20.5035 0.542969 18.9336 2.33507 18.9336 4.54573C18.9336 6.75639 20.5035 8.54848 22.4401 8.54848Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.0768 8.54848C44.0133 8.54848 45.5832 6.75639 45.5832 4.54573C45.5832 2.33507 44.0133 0.542969 42.0768 0.542969C40.1402 0.542969 38.5703 2.33507 38.5703 4.54573C38.5703 6.75639 40.1402 8.54848 42.0768 8.54848Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.4401 30.1632C24.3767 30.1632 25.9465 28.3711 25.9465 26.1605C25.9465 23.9498 24.3767 22.1577 22.4401 22.1577C20.5035 22.1577 18.9336 23.9498 18.9336 26.1605C18.9336 28.3711 20.5035 30.1632 22.4401 30.1632Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.0768 30.1632C44.0133 30.1632 45.5832 28.3711 45.5832 26.1605C45.5832 23.9498 44.0133 22.1577 42.0768 22.1577C40.1402 22.1577 38.5703 23.9498 38.5703 26.1605C38.5703 28.3711 40.1402 30.1632 42.0768 30.1632Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.0768 52.5787C44.0133 52.5787 45.5832 50.7867 45.5832 48.576C45.5832 46.3653 44.0133 44.5732 42.0768 44.5732C40.1402 44.5732 38.5703 46.3653 38.5703 48.576C38.5703 50.7867 40.1402 52.5787 42.0768 52.5787Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.3092 8.54848C62.2457 8.54848 63.8157 6.75639 63.8157 4.54573C63.8157 2.33507 62.2457 0.542969 60.3092 0.542969C58.3727 0.542969 56.8027 2.33507 56.8027 4.54573C56.8027 6.75639 58.3727 8.54848 60.3092 8.54848Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.3092 30.1632C62.2457 30.1632 63.8157 28.3711 63.8157 26.1605C63.8157 23.9498 62.2457 22.1577 60.3092 22.1577C58.3727 22.1577 56.8027 23.9498 56.8027 26.1605C56.8027 28.3711 58.3727 30.1632 60.3092 30.1632Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.3092 52.5787C62.2457 52.5787 63.8157 50.7867 63.8157 48.576C63.8157 46.3653 62.2457 44.5732 60.3092 44.5732C58.3727 44.5732 56.8027 46.3653 56.8027 48.576C56.8027 50.7867 58.3727 52.5787 60.3092 52.5787Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.3092 73.3932C62.2457 73.3932 63.8157 71.6011 63.8157 69.3905C63.8157 67.1798 62.2457 65.3877 60.3092 65.3877C58.3727 65.3877 56.8027 67.1798 56.8027 69.3905C56.8027 71.6011 58.3727 73.3932 60.3092 73.3932Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.2447 8.54848C81.1813 8.54848 82.7516 6.75639 82.7516 4.54573C82.7516 2.33507 81.1813 0.542969 79.2447 0.542969C77.3082 0.542969 75.7383 2.33507 75.7383 4.54573C75.7383 6.75639 77.3082 8.54848 79.2447 8.54848Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.2447 30.1632C81.1813 30.1632 82.7516 28.3711 82.7516 26.1605C82.7516 23.9498 81.1813 22.1577 79.2447 22.1577C77.3082 22.1577 75.7383 23.9498 75.7383 26.1605C75.7383 28.3711 77.3082 30.1632 79.2447 30.1632Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.2447 52.5787C81.1813 52.5787 82.7516 50.7867 82.7516 48.576C82.7516 46.3653 81.1813 44.5732 79.2447 44.5732C77.3082 44.5732 75.7383 46.3653 75.7383 48.576C75.7383 50.7867 77.3082 52.5787 79.2447 52.5787Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.2447 73.3932C81.1813 73.3932 82.7516 71.6011 82.7516 69.3905C82.7516 67.1798 81.1813 65.3877 79.2447 65.3877C77.3082 65.3877 75.7383 67.1798 75.7383 69.3905C75.7383 71.6011 77.3082 73.3932 79.2447 73.3932Z"
      fill="#F6B0B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.2447 95.0077C81.1813 95.0077 82.7516 93.2153 82.7516 91.0048C82.7516 88.7943 81.1813 87.002 79.2447 87.002C77.3082 87.002 75.7383 88.7943 75.7383 91.0048C75.7383 93.2153 77.3082 95.0077 79.2447 95.0077Z"
      fill={props.color ?? "#F6B0B0"}
    />
  </svg>
);
